export enum RepairPaymentTypeEnum {
  'PerHour' = 'PerHour',
  'PerDay' = 'PerDay',
  'SetPrice' = 'SetPrice',
  'Percentage' = 'Percentage',
  'ExtraHours' = 'ExtraHours',
}
